import { render, staticRenderFns } from "./shopeechat.vue?vue&type=template&id=66e14fa6"
import script from "./shopeechat.vue?vue&type=script&lang=js"
export * from "./shopeechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports